/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Cur } from '../models/Cur';
import type { CurIn } from '../models/CurIn';
import type { CurList } from '../models/CurList';
import type { ListArgs } from '../models/ListArgs';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CurService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Cur Objects List
     * @param requestBody
     * @returns CurList Successful Response
     * @throws ApiError
     */
    public getCurList(
        requestBody: ListArgs,
    ): CancelablePromise<CurList> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/Cur',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cur Object Create
     * @param requestBody
     * @param itemId
     * @returns Cur Successful Response
     * @throws ApiError
     */
    public newCur(
        requestBody: CurIn,
        itemId?: (number | null),
    ): CancelablePromise<Cur> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/Cur',
            query: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cur Object Get
     * @param itemId
     * @returns Cur Successful Response
     * @throws ApiError
     */
    public getCur(
        itemId: number,
    ): CancelablePromise<Cur> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/Cur/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cur Object Update
     * @param itemId
     * @param requestBody
     * @returns Cur Successful Response
     * @throws ApiError
     */
    public updCur(
        itemId: (number | null),
        requestBody: CurIn,
    ): CancelablePromise<Cur> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v2/Cur/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Cur Object Delete
     * @param itemId
     * @returns any Successful Response
     * @throws ApiError
     */
    public delCur(
        itemId: number,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/Cur/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
